import React from "react";
import { useFela } from "react-fela";
import useTranslation from "next-translate/useTranslation";

import { Grid } from "@/components/Grid";
import { Heading } from "@/components/Heading";
import { LinkButton } from "@/components/LinkButton";

import { useTheme } from "@/hooks/useTheme";
import { CALENDLY_LINK_PRODUCT_DEMO } from "@/constants/pricing";
import { IExcitedToJoinSection } from "./types";

type IProps = IExcitedToJoinSection & JSX.IntrinsicElements["div"];

export const ExcitedToJoinSection: React.FC<IProps> = ({
  title,
  text,
  rightSectionText,
  wrapperBgColor = "#fff",
  buttonLabel,
  href,
  onButtonClick,
  requestDemoLink = CALENDLY_LINK_PRODUCT_DEMO,
  ...rest
}) => {
  const { css } = useFela();
  const { bp, colors } = useTheme();
  const { t } = useTranslation();

  return (
    <Grid
      id="ExcitedToJoinSection"
      customStyle={{
        flexDirection: "column",
        [bp.FROM_TABLET]: {
          flexDirection: "row",
        },
      }}
      wrapperStyle={{
        backgroundColor: wrapperBgColor,
      }}
      {...rest}
    >
      <div
        className={css({
          display: "flex",
          flexDirection: "column",
          justifyContent: "center",
          alignItems: "center",
          [bp.FROM_TABLET]: {
            flexBasis: "50%",
            alignItems: "flex-start",
            justifyContent: "space-between",
          },
        })}
      >
        <Heading
          as="h2"
          customStyle={{
            marginBottom: 16,
            color: colors.DARK_GREY,
            textAlign: "left",
            letterSpacing: "-0.01rem",
          }}
        >
          {title}
        </Heading>
        {text && (
          <p
            className={css({
              fontSize: 18,
              lineHeight: "26px",
              letterSpacing: 0.64,
              color: colors.GRAY,
              fontWeight: 700,
            })}
          >
            {text}
          </p>
        )}

        <LinkButton
          href={requestDemoLink}
          target="_blank"
          customStyle={{ maxWidth: 190, marginTop: 22 }}
          title={t("common:scheduleDemo")}
        />
      </div>
      <div
        className={css({
          display: "flex",
          justifyContent: "center",
          marginTop: 30,
          [bp.FROM_TABLET]: {
            maxWidth: 460,
            flexBasis: "50%",
            margin: 0,
            padding: "0 20px",
            fontSize: 18,
            color: colors.GRAY,
          },
        })}
      >
        {rightSectionText}
      </div>
    </Grid>
  );
};
